import { graphql } from "relay-runtime"

export const chDeleteProgressNotesMutation = graphql`
  mutation chDeleteProgressNotesMutation($input: Ch_deleteProgressNotesInput!, $connections: [ID!]!) {
    deleteProgressNotes: ch_deleteProgressNotes(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      progressNote: ch_ProgressNote {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
